module.exports = __webpack_public_path__ + "media/images/bg-started-contents-top-3da23ea0.png";